import React from "react";
import { Theme } from "@literati/public-ui-shared-react";
import GuidedSignUpFaq from "components/GuidedSignUp/GuidedSignUpFaq";

export interface MembershipFaqSelectPlanProps {
  className?: string;
}

export const MembershipFaqSelectPlan = ({
  className = "",
}: MembershipFaqSelectPlanProps) => {
  return (
    <Theme>
      <GuidedSignUpFaq
        className={className}
        questionAnswers={[
          {
            question: "How does the 30 day annual trial work?",
            answer: `If you’re not fully satisfied, reach out within the first 30 days and we will refund your yearly subscription. 
                  If you still have books at home, we kindly ask you to return them to us at no cost to you. 
                  You will also have the option to purchase any that you’d like to keep at a discount.`,
          },
          {
            question: "How do you pick books for my reader?",
            answer: `We start with their age and reading level to choose books that are just right. 
                  Then we factor in topics they like, new genres for them to explore, and which types of books they’ve kept so far. 
                  Rating books in the app helps us understand what your reader loves!`,
          },
          {
            question: "How many books do I get?",
            answer: `Each box comes with 5 books that you can purchase or just enjoy for the time you have the box. 
                  You’ll get a new box of books every month, unless you decide to change your cadence using the app or by contacting our team.`,
          },
          {
            question: "How long can I keep the books?",
            answer: `You can keep a box of books for up to 14 days while your subscription is active. 
                  After that period, If you send back all of the books in good shape, there is no additional charge. 
                  If you’d like to keep any, you can purchase them at our guaranteed-to-beat-Amazon prices. There is no obligation to purchase books.`,
          },
          {
            question: "How do returns work?",
            answer: `Shipping and returns are always free. A prepaid return label comes in every box. 
                  Just put the books you don’t want back in the box you received, stick the return label on it, 
                  and schedule a pickup with USPS. They’ll take it from there.`,
          },
          {
            question: "How do Annual Book Credits work?",
            answer: `By committing to a year of reading, you’ll automatically get Book Credits added to your account. 
                Book Credits get used towards any books you decide to keep. 
                You won’t get charged for books you keep until you have run out of Book Credits.`,
          },
        ]}
      />
    </Theme>
  );
};

export default MembershipFaqSelectPlan;
